module.exports = __webpack_public_path__ + "img/info-1.92f1b46e.svg";